<button 
        type="button"  class="btn btn-primary btn-circle"  placement="left" *ngIf="isComplete" 
></button>

<ng-template #popTemplate>
        <div class="popover-width" *ngFor="let msg of data">        
        <h6 class="font-weight-bolder" *ngIf="msg.includes(':') || msg.includes('created') ;else other_content">{{msg}}</h6>
        <ng-template #other_content><h6 class="ml-3">{{msg}}</h6></ng-template>
        </div>
</ng-template>

<button 
        type="button" class="btn btn-danger btn-circle" [container]="'body'" placement="left" triggers="mouseenter:mouseleave" *ngIf="!isComplete"  
        [popover]="popTemplate">
</button>